// 以下代码是一些常量命名 --------------------
var qs = require('qs');
var axios = require('axios');
var md5 = require('md5');
var copy = require('./extend');
var errCode = require('./code');
var talUserCenterDeviceInfo = require('@udc/tal-deviceinfo-jssdk');
var reqApplication = 'application/x-www-form-urlencoded; charset=UTF-8';
var header = {};
var _getDomain = ''
var TALDeviceId =''
var setUcresHost = ''
var initConfig = {}
import SetLoadAes from './loadAes.js'
import SetAesField from './aesField.js'
import getSafeFieldData from './safeField.json'

import {
    Promise
} from "es6-promise";
window.Promise = Promise;
axios.defaults.withCredentials = true;
axios.defaults.crossDomain = true;
axios.defaults.xsrfCookieName = 'TAL-XSRF-TOKEN';
axios.defaults.xsrfHeaderName = 'TAL-X-XSRF-TOKEN';
//声明一个数组用于存储每个ajax请求的取消函数和ajax标识
var pending = [];
//初始化取消请求的构造函数
var getCancelToken = axios.CancelToken
var removePending = (config, f) => {
    var flagUrl = config.url + '&' + config.method
    if (pending.indexOf(flagUrl) !== -1) {
        if (f) {
            f()
        }
    } else {
        if (f) {
            pending.push(flagUrl)
        }
    }
}
/**
* 解析字符串，将key=main_choose_grade_id&value=3这样的字符串转换成一个带有=前键值的对象方法
* param     {String} str   字符串
* @return   {Object} 返回str转换后的对象
*/
function parseStrToObject(str){
  if (str) {
    var changeObject = {}, arr = [];
    //将字符串以&为分割点转换成数组
    arr = str.split("&");
    //循环字符串转换为了对应键值的对象,字符串必须是ey=main_choose_grade_id&value=3格式
    for(var i = 0; i < arr.length; i ++) {
      changeObject[decodeURIComponent(arr[i].split("=")[0])] = decodeURIComponent((arr[i].split("="))[1]);
    }
    return changeObject;
  } else {
    return {}
  }
}
/**
* 本地缓存sessionStorage的容错处理，解决Safari开启无痕模式后，localStorage和sessionStorage为空，对其进行set操作也会报错
*/
var resetSessionStorage = {
  setItem(key, value){
    try {
      window.sessionStorage.setItem(key, value) 
    } catch (err) {
      window[key] = value
    }
  },
  getItem(key) {
    try {
      return window.sessionStorage.getItem(key) || '' 
    } catch (err) {
      return window[key] || ''
    }
  },
  removeItem(key) {
    try {
      window.sessionStorage.removeItem(key)
    } catch (err) {
      window[key] = ''
      delete[key]
    }        
  }
}
/**
* 封装axios请求
* param     {String} str   字符串
* @return   {String} 返回str
*/
axios.interceptors.request.use((res) => {
    if (res.method != 'options') {
        // res.cancelToken = new getCancelToken((c) => {
        //     removePending(res, c);
        // });
        var cancelGroupName = '',
            formType = 'formdata'
        if (res.method === 'post') {
            // 字符串形式转换为对象
            if ((typeof res.data == 'string') && res.data) {
                res.data = parseStrToObject(res.data)
                formType = ''
            }
            // post请求ajax取消函数配置
            if (res.data && res.data.cancelGroupName) {
              cancelGroupName = res.data.cancelGroupName
            }

            if (!formType) {
                res.data = qs.stringify(res.data)
            }
        }
        if(res.method === 'get'){
             // get请求ajax取消函数配置
            if (res.params && res.params.cancelGroupName) {
              cancelGroupName = res.params.cancelGroupName
            }
        }
        if (cancelGroupName) {
          if (axios[cancelGroupName] && axios[cancelGroupName].cancel) {
            axios[cancelGroupName].cancel()
          }
          res.cancelToken = new getCancelToken(c => {
            axios[cancelGroupName] = {}
            axios[cancelGroupName].cancel = c
          })
        }
    }
    for (var i in header) {
        res.headers[i] = header[i];
    }
    res.headers['Server-Origin'] = 'js-sdk';
    res.headers['device-id'] = _util.createdDeviceId();
    res.headers['ver-num'] = process.env.SET_VERSION;
    return res
})
axios.interceptors.response.use((res) => {
    var flagUrl = res.config.url + '&' + res.config.method;
    if (pending.indexOf(flagUrl) !== -1) {
        pending.splice(pending.indexOf(flagUrl), 1)
    }
    /** 判断是否是校验登录态接口
     ** 请求完成之后，不管接口成功与否，判断响应头是否存在Set-Tal-Token字段，如果存在该字段，则无论该字段的值是否为空均本地存储sessionStorage tal-passport-jssdk-tal-token字段，否则不作处理
    **/
    // 获取请求响应头respose headers数据
    var getResposeHeadersData = res.headers || {}
    // 获取响应头字段键值数组
    var getResposeHeadersKeyArr = Object.keys(getResposeHeadersData) || []
    var ResposeHeadersKeyArr = getResposeHeadersKeyArr.map(function(item, index){
        return item.toLowerCase()
    })
    // 判断是否存在Set-Tal-Token字段，存在本地存储sessionStorage，否则不做任何处理
    if (ResposeHeadersKeyArr.indexOf('set-tal-token') != -1) {
      var getTalToken = getResposeHeadersData['set-tal-token'] || ''
      getTalToken = (getTalToken && getTalToken != 'deleted') ? getTalToken : ''
      if (getTalToken) {
        resetSessionStorage.setItem('tal-passport-jssdk-tal-token', getTalToken)
      } else {
        resetSessionStorage.removeItem('tal-passport-jssdk-tal-token')
      }
      console.log(getTalToken,'==getTalToken==')
    }
    return res.data
})
var _util = {
    setHeader: function (headers, domain, ucresHost, options) {
        initConfig = options || {}
        setUcresHost = ucresHost
        header = headers;
        var _domains = ["com","net","org","gov","cn","com\\.cn","net\\.cn","org\\.cn","gov\\.cn","[a-z]{2}\\.cn","vip","tech","tv","co","live","xyz","top","info","mobi","group","中国"]
        var _str = _domains.join("|")
        var _pattern = new RegExp("[\\w-_]+\\.(" + _str + ")$","i")
        var _res = _pattern.exec(domain);
        _res = _res || []
        _getDomain = _res[0] || ''
        if (!_getDomain) {
          // 定级域名不合法
          console.log('******------域名不在合法的范围内------******')
        }
    },
    // 根据业务入口设置接口域名
    setBusinessDomain: function (entity) {
      var entityDomain = ''
      var resDomain = ''
      switch (entity) {
        case 2: 
          // vdyoo的域名
          entityDomain = 'passport.vdyoo.com'
          resDomain = 'ucres.saasz.vdyoo.com'
          console.log('===vdyoo===')
          break;
        default:
          // 100tal的域名
          entityDomain = 'passport.100tal.com'
          resDomain = 'ucres.100tal.com'
          console.log('===100tal===')
      }
      return {
        entityDomain: entityDomain,
        resDomain: resDomain
      }
    },
    // 根据环境&业务入口设置接口域名
    setRequestDomain (env, domain, entity) {
      var set_passport_host_v1 = ''
      var set_passport_host_v2 = ''
      var set_cg_host_v1 = ''
      var set_cg_host_v2 = ''
      var set_ucresHost = ''
      var getBusinessDomain = this.setBusinessDomain(entity) || {}
      var resDomain = getBusinessDomain.resDomain
      var entityDomain = getBusinessDomain.entityDomain
      switch (env) {
        case 'sandbox':
          set_passport_host_v1 = 'https://test-' + entityDomain + '/v1';
          set_passport_host_v2 = 'https://test-' + entityDomain;
          set_ucresHost = 'https://test-' + resDomain;
          if (domain) {
            set_cg_host_v1 = 'https://test-' + domain +  '/v1';
            set_cg_host_v2 = 'https://test-' + domain;
          }
          // 内部demo需要判断环境
          window.envString = 'sandbox';
          break;
        default:
          set_passport_host_v1 = 'https://' + entityDomain + '/v1';
          set_passport_host_v2 = 'https://' + entityDomain;
          set_ucresHost = 'https://' + resDomain;
          if (domain) {
            set_cg_host_v1 = 'https://' + domain +  '/v1';
            set_cg_host_v2 = 'https://' + domain;
          }
      }
      // 如果业务方初始化sdk的时候，不传domain，则依然接口走passport域名
      if (!domain) {
        set_cg_host_v1 = set_passport_host_v1;
        set_cg_host_v2 = set_passport_host_v2;
      }
      return {
        passport_host_v1: set_passport_host_v1,
        passport_host_v2: set_passport_host_v2,
        cg_host_v1: set_cg_host_v1,
        cg_host_v2: set_cg_host_v2,
        ucresHost: set_ucresHost
      }
    },
    // aes加密字段方法
    aesEncryptFieldFn (params) {
      return new Promise(function(resolve, reject){ 
        // 统一拦截请求参数，对应的数据做aes加密
        let getAllParams = params || {},
            getFieldList = getSafeFieldData.fieldList || [],
            aesFieldAllPromise = []
        for (let key in getAllParams) {
          if (getFieldList.indexOf(key) != -1) {
            let getFieldVal = getAllParams[key]
            aesFieldAllPromise.push(SetAesField(setUcresHost, getFieldVal, key))
          }
        }
        Promise.all(aesFieldAllPromise).then(function(result) {
          let getResultArr = result || []
          for(let i = 0; i　< getResultArr.length; i++) {
            getAllParams[getResultArr[i].encryptFieldKey] = getResultArr[i].encryptResult
          }
          resolve(getAllParams)
        }).catch(function(error) {
          reject(error)
        })
      })
      // console.log(id, '==getAllParams===')
      // return new Promise(function(resolve, reject){ 
      // })
    },
    /*
    * @discribe 用于merge传入对象和身份对象UserInfo
    * @method getParams
    * @param [userInfo, params]
    * @return {Object} 返回一个从新整合的对象
    * TODO 未处理对象的字段目前暂未定义完全
    * */
    getParams: function (params) {
        return copy.extend(true, {}, params)
    },
    /*
    * @discribe 用于对传入字段进行MD5加密
    * @method md5Code
    * @param {message}
    * @return {String} 返回MD5加密后的字符串
    * TODO 未处理对象的字段目前暂未定义完全
    * */
    md5Code: function (message) {
        return md5(message)
    },
    /*
    * @discribe 手机号的验证，需要传入手机号和地区
    * 不同地区的手机号，验证方式也不相同
    * @method validPhone
    * @param [phone, area]
    * @return {Boolean} 返回一个布尔值
    * TODO 未处理对象的字段目前暂未定义完全
    * */
    validPhone: function (phone, area) {
        if (/^(\+|0)?86$/.test(area)) {
            // 大陆
            return /^1[3456789]\d{9}$/.test(phone)
        }
        return true
    },
    /*
    * @discribe 用于验证传入的数据中是否存在不是必填字段传的空，如果非必填字段传空，删除掉
    * @method validEmptyKey
    * @param {params}所有字段对象 {notValid}对象中无需验证的字段例如：phone字段是必填字段在其他的方法中验证过了
    * @return {Object} 返回一个从新处理的对象
    * TODO 未处理对象的字段目前暂未定义完全
    * */
    validEmptyKey: function (params, notValid) {
        var obj = copy.extend(true, {}, params);
        for (var i in obj) {
            if (notValid.indexOf(i) > -1) {
                continue;
            } else {
                if (obj[i] === '') {
                    delete obj[i];
                }
            }
        }
    },
    /*
    * @discribe 获取
    * @method getCode
    * @param {resolver} 初始化对象的回调函数
    * @return {Object} 返回一个Promise对象
    * TODO 未处理对象的字段目前暂未定义完全
    * */
    getCode: function (code) {
        return (errCode[code]);
    },
    /*
    * @discribe 获取时间戳
    * @method timstamp
    * @param {resolver} 初始化对象的回调函数
    * @return {Object} 返回一个Promise对象
    * TODO 未处理对象的字段目前暂未定义完全
    * */
    getTimstamp: function () {
        return parseInt(new Date().getTime());
    },
    /*
    * @discribe 退出登录的相关操作
    * @param {res} 请求的url {params} 请求参数    
    * */
    logoutOperate (params) {
        var _t = this
        // 退出的时候清除检测心跳的本地缓存和心跳定时器以及本地存储的tal-token
        var get_isheartbeat = _t.resetLocalStorage.getItem("tal-passport-open-heartbeat-tag") || ''
        if (get_isheartbeat) {
            _t.resetLocalStorage.removeItem("tal-passport-open-heartbeat-tag")
        }
        if (window.tal_passport_setheartbeat_flag) {
            window.clearInterval(window.tal_passport_setheartbeat_flag)
        }
        resetSessionStorage.removeItem('tal-passport-jssdk-tal-token')
        // 判断是否为http/https协议，是执行cookie存储，否则执行localStorage存储，目的为了解决非http/https协议下无法存储cookie问题
        if (_t.isHttpProtocol()) {
          // http/https协议
          _t.delCookie('tal-passport-run-heartbeat-timeStamp', _getDomain)
        } else {
          // 非http/https协议
          _t.resetLocalStorage.removeItem('tal-passport-run-heartbeat-timeStamp')
        }
        // 接口失败/成功均执行成功回调
        var setRes = { 
            "errcode": 0,
            "errmsg": "请求成功",
            "data": { 
               "result": "退出成功"
            }
        }
        if (params.success && typeof params.success === 'function') {
            params.success(setRes);
        }
    },
    /*
    * @discribe axios的get方法
    * @method axiosGet
    * @param {res} 请求的url {params} 请求参数
    * @return {Promise} 返回一个Promise对象
    * TODO 未处理对象的字段目前暂未定义完全
    * */
    axiosGet: function (url, params, setSpecialParams) {
        var isLogoutUrl = url.indexOf('/web/login/logout'),
            _t = this;
        // 设置请求头
        var setHeaders = {}
        setSpecialParams = setSpecialParams || {}
        var requestHeaderArr = setSpecialParams.addHeaders || []
        for(var i = 0; i < requestHeaderArr.length; i ++) {
          setHeaders[requestHeaderArr[i].fieldName] = requestHeaderArr[i].fieldValue
        }
        if (setSpecialParams.isCheckLogin) {
          // 判断是否需要校验登录态，校验登录态的接口需要添加Tal-Token 的header头字段
          setHeaders['Tal-Token'] = resetSessionStorage.getItem('tal-passport-jssdk-tal-token') || ''
        }
        var _paramsData = params.data ? params.data : {}
        // 判断是否有需要aes加密的参数字段
        var getAesFieldList = getSafeFieldData.fieldList || [],
            isExitAesField = false
        for (let key in _paramsData) {
          if (getAesFieldList.indexOf(key) != -1) {
            isExitAesField = true
          }
        }
        if (isExitAesField) {
          var aesHeader = 'single/1.1/web_' + getSafeFieldData.version
          setHeaders['Tal-Encrypt-Type'] = aesHeader
        }
        var fn_name = setSpecialParams.name || ''
        _t.aesEncryptFieldFn(_paramsData).then(function(aesParams){
          axios.get(url, {
            params: aesParams || {},
            headers: setHeaders
          }).then(function (res) {
              try {
                  if (isLogoutUrl != -1) {
                    // 退出接口不管成功与否均执行成功
                    _t.logoutOperate(params)
                    // 登录失效回调
                    if (fn_name && initConfig && initConfig.loginout_callback && typeof initConfig.loginout_callback === 'function') {
                      res.name = fn_name
                      initConfig.loginout_callback(res);
                    }
                  } else {
                    params.success ? params.success(res) : function (res) {
                    }
                    params.complete ? params.complete(res) : function (complete) {
                    }
                    var get_errcode = parseInt(res.errcode)
                    // 当错误码为 11100-11199 时即未登录/登录失效，清除检测心跳的本地缓存和心跳定时器以及删除本地存储tal-token
                    if ( get_errcode >= 11100 && get_errcode <= 11199) {
                        // 退出的时候清除检测心跳的本地缓存和心跳定时器
                        var get_isheartbeat = _t.resetLocalStorage.getItem("tal-passport-open-heartbeat-tag") || ''
                        if (get_isheartbeat) {
                            _t.resetLocalStorage.removeItem("tal-passport-open-heartbeat-tag")
                        }
                        if (window.tal_passport_setheartbeat_flag) {
                            window.clearInterval(window.tal_passport_setheartbeat_flag)
                        }
                        resetSessionStorage.removeItem('tal-passport-jssdk-tal-token')
                        // 判断是否为http/https协议，是执行cookie存储，否则执行localStorage存储，目的为了解决非http/https协议下无法存储cookie问题
                        if (_t.isHttpProtocol()) {
                          // http/https协议
                          _t.delCookie('tal-passport-run-heartbeat-timeStamp', _getDomain)
                        } else {
                          // 非http/https协议
                          _t.resetLocalStorage.removeItem('tal-passport-run-heartbeat-timeStamp')
                        }
                        // 登录失效回调
                        if (fn_name && initConfig && initConfig.loginout_callback && typeof initConfig.loginout_callback === 'function') {
                          res.name = fn_name
                          initConfig.loginout_callback(res);
                        }
                    }
                  }
              } catch(err) {}
          }).catch(function (fail) {
              if (isLogoutUrl != -1) {
                  // 退出接口不管成功与否均执行成功
                  _t.logoutOperate(params)
                  if (fn_name && initConfig && initConfig.loginout_callback && typeof initConfig.loginout_callback === 'function') {
                    var newRes = {}
                    if (typeof fail == 'object') {
                      newRes = fail
                    } else {
                      newRes.errmsg = fail
                    }
                    newRes.name = fn_name
                    initConfig.loginout_callback(newRes);
                  }
              } else {
                  params.fail ? params.fail(fail) : function (fail) {
                  }
                  params.complete ? params.complete(fail) : function (fail) {
                  }
              }
          })
        }).catch(function(err){
          var _setRes = _t.getCode(1000002)
          params.success ? params.success(_setRes) : function (res) {}
          params.complete ? params.complete(_setRes) : function (complete) {}
        })
    },
    /*
    * @discribe axios的post方法
    * @method axiosPost
    * @param {res} 请求的url {params} 请求参数
    * @return {Promise} 返回一个Promise对象
    * TODO 未处理对象的字段目前暂未定义完全
    * */
    axiosPost: function (url, params, setSpecialParams) {
        var _t = this
        setSpecialParams = setSpecialParams || {}
        var _paramsData = params.data ? params.data : {}
        // 设置请求头
        var setHeaders = {
              'Content-Type': setSpecialParams.headersType || reqApplication
            }
        var requestHeaderArr = setSpecialParams.addHeaders || []
        for(var i = 0; i < requestHeaderArr.length; i ++) {
          setHeaders[requestHeaderArr[i].fieldName] = requestHeaderArr[i].fieldValue
        }
        if (setSpecialParams.isCheckLogin) {
          // 判断是否需要校验登录态，校验登录态的接口需要添加Tal-Token 的header头字段
          setHeaders['Tal-Token'] = resetSessionStorage.getItem('tal-passport-jssdk-tal-token') || ''
        }
        // 判断是否有需要aes加密的参数字段
        var getAesFieldList = getSafeFieldData.fieldList || [],
            isExitAesField = false
        for (let key in _paramsData) {
          if (getAesFieldList.indexOf(key) != -1) {
            isExitAesField = true
          }
        }
        if (isExitAesField) {
          var aesHeader = 'single/1.1/web_' + getSafeFieldData.version
          setHeaders['Tal-Encrypt-Type'] = aesHeader
        }
        var fn_name = setSpecialParams.name || ''
        _t.aesEncryptFieldFn(_paramsData).then(function(aesParams){
          var data = setSpecialParams.type == 'formdata' ? aesParams : qs.stringify(aesParams)
          axios.post(url, data, {
              headers: setHeaders
          }).then(function (res) {
              try {
                  params.success ? params.success(res) : function (res) {
                  }
                  params.complete ? params.complete(res) : function (res) {
                  }
                  var get_errcode = parseInt(res.errcode)
                  // 当错误码为 11100-11199 时即未登录/登录失效，清除检测心跳的本地缓存和心跳定时器
                  if (get_errcode >= 11100 && get_errcode <= 11199) {
                      // 退出的时候清除检测心跳的本地缓存和心跳定时器
                      var get_isheartbeat = _t.resetLocalStorage.getItem("tal-passport-open-heartbeat-tag") || ''
                      if (get_isheartbeat) {
                          _t.resetLocalStorage.removeItem("tal-passport-open-heartbeat-tag")
                      }
                      if (window.tal_passport_setheartbeat_flag) {
                         window.clearInterval(window.tal_passport_setheartbeat_flag)
                      }
                      resetSessionStorage.removeItem('tal-passport-jssdk-tal-token')
                      // 判断是否为http/https协议，是执行cookie存储，否则执行localStorage存储，目的为了解决非http/https协议下无法存储cookie问题
                      if (_t.isHttpProtocol()) {
                        // http/https协议
                        _t.delCookie('tal-passport-run-heartbeat-timeStamp', _getDomain)
                      } else {
                        // 非http/https协议
                        _t.resetLocalStorage.removeItem('tal-passport-run-heartbeat-timeStamp')
                      }
                      // 登录失效回调
                      if (fn_name && initConfig && initConfig.loginout_callback && typeof initConfig.loginout_callback === 'function') {
                        res.name = fn_name
                        initConfig.loginout_callback(res);
                      }
                  }
              } catch(err) {}
          }).catch(function (fail) {
              params.fail ? params.fail(fail) : function (fail) {
              }
              params.complete ? params.complete(fail) : function (fail) {
              }
          })
        })
    },
    /*
    * @discribe 验证必填字段是否为空。
    * @method validInfo
    * @param {res} 请求的url
    * @return {Boolean} 返回一个布尔值作为对象信息的验证
    * TODO 未处理对象的字段目前暂未定义完全
    * */
    validInfo: function (info, validKeyArr) {
        var len = validKeyArr.length;
        for (var i = 0; i < len; i++) {
            if (!info[validKeyArr[i]]) return true
        }
        return false;
    },
    /*
   * @discribe 验证密码是否符合规则。
   * @method validatePwd
   * @param {pwd} 传入的密码
   * @return {Boolean} 返回一个布尔值作为对象信息的验证
   * */
    validPwd: function (pwd) {
        var len = pwd.length
        var patten = /[]/
        if (len < 8 || len > 16) {
            return false
        }
        if (/^\d*$/g.test(pwd)) {
            return false
        }
        if (/\s/g.test(pwd)) {
            return false
        }
        if (/^[a-zA-Z]*$/g.test(pwd)) {
            return false
        }
        if (!/[0-9A-Za-z]/.test(pwd)) {
            return false
        }
        return true
    },
    /*
    * @discribe 验证参数是否不为空。
    * @method validNotEmpty
    * @param {data} 需要验证的对象
    * @return {Boolean} 返回一个布尔值作为对象信息的验证
    * */
    validNotEmpty: function (data) {
        if (typeof data == 'object') {
            if (!Object.keys(data).length) {
                return false
            }
            return true
        }
        if (typeof data == 'string') {
            if (data == '') {
                return false
            }
            return true
        }
        if (typeof data == 'Number') {
            if (data.length == 0) {
                return false
            }
            return true
        }
    },
    /*
    * @discribe 验证是否是一个数字
    * @method validNum
    * @param {data} 需要验证的对象
    * @return {Boolean} 返回一个布尔值作为对象信息的验证
    * */
    validNum: function (num) {
        var a = /^\d/g;
        return a.test(num);
    },
    /*
    * @discribe 对字符串去空格
    * @method trim
    * @param {str} 需要验证的对象
    * @return {String} 返回一个处理后的字符串
    * */
    trim: function (str) {
        if (String.prototype.trim) {
            return str.trim();
        } else {
            return str.replace(/^\s+|\s+$/g, "");
        }
    },
    /* @discribe 验证验证码是否合法
    * @method validNum
    * @param {data} 需要验证的对象
    * @return {Boolean} 返回一个布尔值作为对象信息的验证
    * */
    validVCode: function (code) {
        var a = /^\d{6}$/g,
            b = /^\d{4}$/g,
            validFlag = a.test(code) || b.test(code)
        return validFlag;
    },
    /* @discribe 验证验证码是否合法
    * @method validResHeader
    * @param {data} 全局变量中的header对象
    * @return {Boolean} 返回一个布尔值作为对象信息的验证
    * */
    validResHeader: function () {
        var headerArr = ['client-id']
        for (var i = 0; i < headerArr.length; i++) {
            var item = headerArr[i]
            if (!header[item]) {
                return false
            }
        }
        return true
    },
    validEmpty: function (str) {
        return /^\s*$/.test(str) || str.length == 0
    },
    axios: axios,
    // 事件绑定
    addEvent: function (event, el, fn) {
        if (el.addEventListener) {
          el.addEventListener(event[0], fn, true);
        } else if (el.attachEvent) {
          el.attachEvent(event[event.length > 1 ? 1 : 0], fn);
        }
    },
    // 日志监听的域名
    logDomains: [
        'alicdn.com',
        'aliyun.com',
        'alibaba.com',
        'aliapp.org',
        'giocdn.com',
        'test-passport.100tal.com',
        'passport.100tal.com'
    ],
    // 判断资源和ajax的url是否在上报日志的范围内
    canLogDomain: function (url) {
        var flag = false,
            logDomainArr = this.logDomains;
        for (var i = logDomainArr.length - 1; i >= 0; i--) {
            if (url.indexOf(logDomainArr[i]) != -1) {
               flag = true
            }
        }
        return flag;
    },
    // 资源加载错误
    resourceError: function (evt, logHost) {
        // 目前只统计script一种资源错误
        if (!(evt.target.tagName)) return false;
        if (evt.target.tagName.toLowerCase() == 'script') {
            var  errorData = {};
            // 记录页面错误元素
            var  target = evt.target ? evt.target : evt.srcElement;
            // 记录错误时间戳
            errorData.timestamp = evt.timeStamp || "";
            errorData.outerHTML = (target && target.outerHTML).slice(0, 200);
            errorData.type = "Resource";
            errorData.url = evt.target && evt.target.src || evt.target.href || "";
            errorData.baseURI = evt.target && evt.target.baseURI || "";
            errorData.tagName = evt.target && evt.target.tagName || "";
            // 判断资源是否在允许上报日志的范围内
            if (!this.canLogDomain(errorData.url)) return false;
            //发送日志请求
            var eventParams = {};
            eventParams.data = errorData;
            var eventLogimg = new Image();
            var _appid = '1002228';
            var eventTimesTamp = new Date().getTime();
            var _appkey = '88ef13a121d540837c6d3a22b1510eeb';
            var _sign = md5(_appid + '&' + eventTimesTamp + _appkey);
            // console.log(logHost)
            eventLogimg.src = logHost + '/appid/sys.gif?content=' + encodeURIComponent(JSON.stringify(eventParams)) + "&appid=" + _appid + "&sign=" + _sign + "&clits=" + eventTimesTamp;
        }
    },

    // ajax加载错误
    ajaxError: function (logHost) {
        var _t = this;
        if (XMLHttpRequest) {
            var xhr = new Object();
            xhr.send = XMLHttpRequest.prototype.send;
            xhr.open = XMLHttpRequest.prototype.open;
            // 重写open方法，记录请求的url
            XMLHttpRequest.prototype.open = function (method, url, boolen) {
                if(boolen === undefined){
                  xhr.open.apply(this, [method, url]);
                }else{
                  xhr.open.apply(this, [method, url, boolen]);
                }
                this.ajaxUrl = url;
                this.ajaxStartTime = (new Date).getTime();
                this.ajaxMethod = method;
            };

            // 重写send方法，监控ajax请求
            XMLHttpRequest.prototype.send = function () {
                xhr.send.apply(this, arguments);
                function handler(evt) {
                  if (this.readyState == 4) {
                    const errorData = {};
                    errorData.type = "Ajax";
                    errorData.resourceUrl = this.ajaxUrl || "";
                    if (_t.canLogDomain(errorData.resourceUrl)) {
                        errorData.statusText = this.statusText || "";
                        errorData.status = this.status || "";
                        errorData.elapsedTime = this.ajaxStartTime ? (new Date).getTime() - this.ajaxStartTime : "";
                        errorData.method = this.ajaxMethod;
                        if (this.response && typeof this.response == 'string') {
                            errorData.response = this.response.length > 2000 ? this.response.substr(0, 2000) : this.response;
                        }
                    }
                    // 判断请求是否成功
                    if (this.status >= 200 && this.status < 300 || this.status === 304) {
                      if (this.responseType == '' || this.responseType == 'text') {
                        return this.responseText;
                      } else {
                        //  返回对应请求的 responseType
                        return this.responseType
                      }
                    } else {
                        // console.log(errorData)
                        // 判断资源是否在允许上报日志的范围内
                        if (!_t.canLogDomain(errorData.resourceUrl)) return false;
                        // Ajax异常日志上报
                        var eventParams = {};
                        eventParams.data = errorData;
                        var eventLogimg = new Image();
                        var _appid = '1002228';
                        var eventTimesTamp = new Date().getTime();
                        var _appkey = '88ef13a121d540837c6d3a22b1510eeb';
                        var _sign = md5(_appid + '&' + eventTimesTamp + _appkey);
                        eventLogimg.src = logHost + '/appid/sys.gif?content=' + encodeURIComponent(JSON.stringify(eventParams)) + "&appid=" + _appid + "&sign=" + _sign + "&clits=" + eventTimesTamp;
                    }
                  }
                }
                _t.addEvent(["readystatechange", "onreadystatechange"], this, handler);
            }
        }

    },
    // 上报资源错误日志
    sysLog: function (logHost) {
        var _t = this;
        this.addEvent(["error", "onerror"], window, function(event){
            _t.resourceError(event, logHost)
        });
        this.ajaxError(logHost)
    },

    parseStr: function (str) {
      if (str) {
        var changeObject = {};
        var arr = [];
        // 将字符串以&为分割点转换成数组
        arr = str.split('&');
        // 此处过滤掉无效参数，兼容url结尾& 【hasModifiy】
        arr = arr.filter(x => /\w+=\w*/.test(x));
        // 循环字符串转换为了对应键值的对象,字符串必须是ey=main_choose_grade_id&value=3格式
        for (var i = 0; i < arr.length; i++) {
          changeObject[arr[i].split('=')[0].toLowerCase()] = arr[i].split('=')[1];
        }
        return changeObject;
      } else {
        return {};
      }
    },
    /*
    * @discribe 创建deviceId
    * @method createdDeviceId
    * @param Null
    * @return {String} 返回一个字符串
    * TODO 未处理对象的字段目前暂未定义完全
    * */
    createdDeviceId() {
        talUserCenterDeviceInfo.getTALDeviceId({
            success: function (res) {
                TALDeviceId =  res.data.TALDeviceId
            }
        })
        return TALDeviceId
    },
     /* @discribe 上报设备信息
    * @method upLoadDeviceInfo
    * @param {data} 全局变量中的header对象
    * @return {Boolean} 返回一个布尔值作为对象信息的验证
    * */
    upLoadDeviceInfo: function(URL, params, ucresHost){
        // 上报设备信息
        var str = {
              "deviceInfo": {},
              "systemInfo": {},
              "networkInfo": {},
              "geographyInfo": {},
              "browserInfo": {}
            },
            _t = this

        // 获取设备信息
        window.talUserCenterDeviceInfo.getDeviceInfo({
            success: function (res) {
                str.deviceInfo = res.data
            }
        })
        // 获取浏览器信息
        window.talUserCenterDeviceInfo.getBrowserInfo({
            success: function (res) {
                str.browserInfo = res.data
            }
        })
        SetAesField(ucresHost, JSON.stringify(str)).then(function(res){
          var setParams = {
                data: {
                    str: res.encryptResult || ''
                }
              },
              getNewParams = Object.assign(setParams, params)
          _t.axiosPost(URL, getNewParams)
        }).catch(function(err){})
    },

    /* @discribe 上报设备信息方法二次封装
    *  @method upLoadDeviceInfoFn
    *  @param {String} ucresHost 资源文件域名ucresHost
    *  @param {String} host 接口域名host
    * */
    upLoadDeviceInfoFn (ucresHost, host) {
      var _t = this
      SetLoadAes(ucresHost).then(function(res){
        _t.upLoadDeviceInfo(host+ '/web/device/init', {
            success: function(res) {
                if (res.errcode == 0) {
                    // 记录时间戳
                    _t.resetLocalStorage.setItem('tal-passport-upLoad-deviceInfo-timeStamp', new Date().getTime())
                }
            },
            ucresHost
        })
      }).catch(function(err){})
    },

    /* @discribe 获取url参数
    * @method getUrlParmas
    * @param {data} 全局变量中的header对象
    * @return {Boolean} 返回一个布尔值作为对象信息的验证
    * */
    getUrlParmas: function (url) {
        let vars = {};
        url.replace(/[?&]+([^=&]+)=([^&#]*)/gi, function (m, key, value) {
            vars[key] = value;
        });
        return vars;
    },
   /**
     * @name: isIncludeFile
     * @description: 判断页面是否有某个js或者css
     * @param {msg} name js/css文件名
     * @return {boolean} 有则返回true，无则返回false
    */
   isIncludeFile (name){
        var js = /js$/i.test(name);
        var es = document.getElementsByTagName(js?'script':'link');
        for(var i=0;i<es.length;i++) 
        if(es[i][js?'src':'href'].indexOf(name)!=-1)return true;
        return false;
    },

    /**
     * 补齐数字位数
     * @return {string}
     */
    getNumTwoBit: function(n) {
        n = Number(n);
        return (n > 9 ? '' : '0') + n;
    },

    /**
     * 时间戳转换为日期格式
     * @return {Object}
     */
    timestampToDate: function (timestamp) {
        let date = new Date(timestamp);
        return {
            date: date.getFullYear() + '-' + this.getNumTwoBit((date.getMonth() + 1)) + '-' + this.getNumTwoBit(date.getDate()),
            hours: date.getHours()
        }
    },
    /**
     * 获取当前日期
     * @return {Object}
     */
    getCurrentDate: function () {
        let date = new Date();
        return {
            date: date.getFullYear() + '-' + this.getNumTwoBit((date.getMonth() + 1)) + '-' + this.getNumTwoBit(date.getDate()),
            hours: date.getHours()
        }
    },
    /**
     * 兼容ie删除dom节点
     */
    removeElement: function (_element) {
        var _parentElement = _element.parentNode;
        if(_parentElement){
            _parentElement.removeChild(_element);
        }
    },
    /**
     * 判断是否是微信环境
     */
    isCheckWeChat() { 
        // 判断是否在微信环境下,微信环境下授权
        let flag = true
        let _ua = navigator.userAgent.toLowerCase() 
        if(_ua.match(/MicroMessenger/i) != 'micromessenger') {
            flag = false
        }else{
            flag = true
        }
        return flag
    },
    
    /**
     * 本地缓存localStorage的容错处理，解决Safari开启无痕模式后，localStorage和sessionStorage为空，对其进行set操作也会报错
     */
    resetLocalStorage: {
      setItem(key, value){
        try {
          window.localStorage.setItem(key, value) 
        } catch (err) {
          window[key] = value
        }
      },
      getItem(key) {
        try {
          return window.localStorage.getItem(key) || ''
        } catch (err) {
          return window[key] || ''
        }
      },
      removeItem(key) {
        try {
          window.localStorage.removeItem(key)
        } catch (err) {
          window[key] = ''
          delete[key]
        }
      }
    },
    /**
     * 本地缓存sessionStorage的容错处理，解决Safari开启无痕模式后，localStorage和sessionStorage为空，对其进行set操作也会报错
     */
    resetSessionStorage: resetSessionStorage,

    /**
     * 获取cookie值
     */
    getCookieValue: function (cookieName) {
        var cookieValue = ''
        if (window.document.cookie && window.document.cookie != '') {
          var cookies = document.cookie.split(';')
          for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i],
                splitCookieKey = cookie.split('=')
            if (splitCookieKey[0].trim() == cookieName.trim()) {
              // 预防键值或者值有=字符串
              cookieValue = unescape(cookie.split(cookieName.trim() + '=')[1])
              break
            }  
          }  
        }   
        return cookieValue; 
    },

    /**
     * 设置cookie值
    */
    setCookieValue: function (key, value, domain) {
      if (domain) {
        document.cookie = key + '=' + escape(value) + '; path=/' + '; domain=' + domain;
      } else {
        document.cookie = key + '=' + escape(value) + '; path=/';
      }  
    },

    /**
     * 删除cookie方法
     * @param   {string}   key  cookie键值
     * @param  {Boolean}  domain  cookie设置是否跨域
     */
    delCookie (key, domain) {
      var _this = this
      var exdate = new Date(),
        expiredays = -1;
      exdate.setDate(exdate.getDate() + expiredays);
      var value = _this.getCookieValue(key);
      if (value) {
        //判断是否跨域
        if (domain) {
          document.cookie = key + "=" + escape(value) + ((expiredays == null) ? "" : ";expires=" + exdate.toGMTString()) + ";path=/;domain=" + domain;
        } else {
          document.cookie = key + "=" + escape(value) + ((expiredays == null) ? "" : ";expires=" + exdate.toGMTString()) + ";path=/";
        }
      }
    },
    /**
     * 判断当前域名协议是否为http/https协议
    */
    isHttpProtocol () {
      var _reg = /http[s]{0,1}[:]{0,1}/gi,
          _protocol = window.location.protocol;
      return _reg.test(_protocol)
    }
}

module.exports = _util;



// WEBPACK FOOTER //
// ./src/_util.js